const API_BASE_URL = 'https://stu150255.webhosting.arden.ac.uk/COM6008/api';

export const authAPI = {
  // User registration
  register: async (email, password) => {
    const response = await fetch(`${API_BASE_URL}/users/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Registration failed');
    }

    return response.json();
  },

  // User authentication
  login: async (email, password) => {
    const response = await fetch(`${API_BASE_URL}/auth/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Login failed');
    }

    return response.json();
  },

  // Update user password
  updatePassword: async (email, password, newPassword) => {
    const response = await fetch(`${API_BASE_URL}/users/update/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password, newPassword })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Password update failed');
    }

    return response.json();
  },

  // Get user count
  getUserCount: async () => {
    const response = await fetch(`${API_BASE_URL}/count/`);
    
    if (!response.ok) {
      throw new Error('Failed to get user count');
    }

    return response.json();
  }
};

export const foodAPI = {
  // Get predictions
  getPredictions: async () => {
    const response = await fetch(`${API_BASE_URL}/get-predictions/`);
    
    if (!response.ok) {
      throw new Error('Failed to get predictions');
    }

    return response.json();
  },

  // Create prediction
  predict: async (guests, location, menu) => {
    const response = await fetch(`${API_BASE_URL}/predict/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ guests, location, menu })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Prediction failed');
    }

    return response.json();
  },

  // Get menus
  getMenus: async () => {
    const response = await fetch(`${API_BASE_URL}/menus/`);
    
    if (!response.ok) {
      throw new Error('Failed to get menus');
    }

    return response.json();
  },

  // Get locations
  getLocations: async () => {
    const response = await fetch(`${API_BASE_URL}/locations/`);
    
    if (!response.ok) {
      throw new Error('Failed to get locations');
    }

    return response.json();
  },

  // Get notifications
  getNotifications: async () => {
    const response = await fetch(`${API_BASE_URL}/notifications/`);
    
    if (!response.ok) {
      throw new Error('Failed to get notifications');
    }

    return response.json();
  },

  // Get estimations
  getEstimations: async () => {
    const response = await fetch(`${API_BASE_URL}/estimations/`);
    
    if (!response.ok) {
      throw new Error('Failed to get estimations');
    }

    return response.json();
  },

  // Get analytics
  getAnalytics: async () => {
    const response = await fetch(`${API_BASE_URL}/analytics/`);
    
    if (!response.ok) {
      throw new Error('Failed to get analytics');
    }

    return response.json();
  }
}; 